const getCoverImageUrl = (doc: Playground.SimpleDocument) => {
  return (
    doc.media.find(
      (media: Playground.MediaItem) => media.mimeType.includes('image/') || media.mimeType.includes('video/')
    )?.coverUrl || ''
  )
}
export default getCoverImageUrl
